var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "con-btn"
    },
    [
      _c(
        "div",
        { staticClass: "breadcrumb-layout" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "/" } },
            [
              _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                _vm._v("首页")
              ]),
              _vm._v(" "),
              _c("el-breadcrumb-item", [_vm._v("配货信息")])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "form-single" }, [
        _c("div", { staticClass: "title required" }, [_vm._v("标题")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "content", staticStyle: { width: "366px" } },
          [
            _c("el-input", {
              on: {
                blur: function($event) {
                  _vm.titleBlur()
                }
              },
              model: {
                value: _vm.title,
                callback: function($$v) {
                  _vm.title = $$v
                },
                expression: "title"
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "form-single",
          staticStyle: { overflow: "visible", "margin-bottom": "15px" }
        },
        [
          _c("div", { staticClass: "title required" }, [
            _vm._v("要求到货日期")
          ]),
          _vm._v(" "),
          _c(
            "el-form",
            { ref: "arriveDate", attrs: { rules: _vm.validateRules } },
            [
              _c(
                "div",
                { staticClass: "content" },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "mr20",
                      attrs: { prop: "desireArriveDate" }
                    },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          "picker-options": _vm.pickerOptions0,
                          type: "date",
                          placeholder: "选择日期"
                        },
                        on: { change: _vm.compareDate },
                        model: {
                          value: _vm.desireArriveDate,
                          callback: function($$v) {
                            _vm.desireArriveDate = $$v
                          },
                          expression: "desireArriveDate"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c("table", { staticClass: "custom-tbl" }, [
        _vm._m(2),
        _vm._v(" "),
        _c("tbody", { staticClass: "body" }, [
          _vm.retailerCom != null
            ? _c("tr", { staticClass: "row" }, [
                _c("td", { staticClass: "align-left" }, [
                  _vm._v(_vm._s(_vm.retailerCom.name))
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "align-left" }, [
                  _vm._v(
                    _vm._s(_vm.retailerCom.regionName || "") +
                      _vm._s(_vm.retailerCom.street || "")
                  )
                ]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.retailerCom.contactEmail))])
              ])
            : _c("tr", { staticClass: "row" }, [
                _c("td", { attrs: { colspan: "3" } }, [
                  _vm._v("无配货机构信息")
                ])
              ])
        ])
      ]),
      _vm._v(" "),
      _vm.retailerCom != null && _vm.retailerCom.shopAddrRegionId != null
        ? _c("div", [
            _c("div", { staticClass: "content-caption dashed bg-white" }, [
              _c("span", [_vm._v("收货地址")]),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "swb-btn-link",
                  on: {
                    click: function($event) {
                      _vm.showShopAddrDlg()
                    }
                  }
                },
                [_vm._v("选择")]
              )
            ]),
            _vm._v(" "),
            _c("table", { staticClass: "custom-tbl" }, [
              _vm._m(3),
              _vm._v(" "),
              _vm._m(4),
              _vm._v(" "),
              _c("tbody", { staticClass: "body" }, [
                _vm.retailerCom != null
                  ? _c("tr", { staticClass: "row" }, [
                      _c("td", { staticClass: "align-left" }, [
                        _vm._v(_vm._s(_vm.retailerCom.shopAddrRegionName || ""))
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticClass: "align-left" },
                        [
                          _c("el-input", {
                            staticClass: "inline-block",
                            staticStyle: { width: "500px" },
                            attrs: { placeholder: "详细地址" },
                            model: {
                              value: _vm.retailerCom.shopAddrStreet,
                              callback: function($$v) {
                                _vm.$set(_vm.retailerCom, "shopAddrStreet", $$v)
                              },
                              expression: "retailerCom.shopAddrStreet"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticClass: "align-left" },
                        [
                          _c("el-input", {
                            attrs: { type: "input" },
                            model: {
                              value: _vm.retailerCom.shopRecvContactName,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.retailerCom,
                                  "shopRecvContactName",
                                  $$v
                                )
                              },
                              expression: "retailerCom.shopRecvContactName"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c("el-input", {
                            attrs: { type: "input" },
                            model: {
                              value: _vm.retailerCom.shopRecvContactTel,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.retailerCom,
                                  "shopRecvContactTel",
                                  $$v
                                )
                              },
                              expression: "retailerCom.shopRecvContactTel"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  : _c("tr", { staticClass: "row" }, [
                      _c("td", { attrs: { colspan: "3" } }, [
                        _c(
                          "a",
                          {
                            staticClass: "font-blue",
                            on: {
                              click: function($event) {
                                _vm.showShopAddrDlg()
                              }
                            }
                          },
                          [_vm._v("选择地址")]
                        )
                      ])
                    ])
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._m(5),
      _vm._v(" "),
      _vm._m(6),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-layout" },
        [
          _c(
            "el-form",
            { ref: "goodsOrderItem", attrs: { model: _vm.goodsOrderItem } },
            [
              _c(
                "el-table",
                {
                  ref: "multipleTable",
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.goodsOrderItemList,
                    border: "",
                    "tooltip-effect": "dark"
                  }
                },
                [
                  _vm.showAssetInfo
                    ? _c(
                        "el-table-column",
                        { attrs: { align: "center", label: "资产信息" } },
                        [
                          _c("el-table-column", {
                            attrs: {
                              align: "left",
                              prop: "devcName",
                              label: "名称"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "left",
                              prop: "devcCatName",
                              label: "分类"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "left",
                              prop: "devcBrandName",
                              label: "品牌"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-table-column",
                    { attrs: { align: "center", label: "商品信息" } },
                    [
                      _c("el-table-column", {
                        attrs: { align: "left", prop: "title", label: "名称" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          align: "left",
                          width: "120",
                          prop: "catName",
                          label: "分类"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          align: "left",
                          width: "120",
                          prop: "brandName",
                          label: "品牌"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      prop: "asmblAccFlag",
                      label: "组装件",
                      width: "80"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.asmblAccFlag
                              ? _c("span", [_vm._v("是")])
                              : _c("span", [_vm._v("否")])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "right",
                      prop: "price",
                      label: "含税价(元)",
                      width: "80"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("span", [_vm._v(_vm._s(scope.row.price || 0.0))])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "right",
                      prop: "taxRate",
                      label: "税率(%)",
                      width: "80"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("span", [_vm._v(_vm._s(scope.row.taxRate || 0))])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "right",
                      prop: "ntxPrice",
                      label: "未税价(元)",
                      width: "80"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("span", [
                              _vm._v(_vm._s(scope.row.ntxPrice || 0.0))
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "right",
                      width: "100",
                      prop: "wrntPeriod",
                      label: "质保期（月）"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "right",
                      width: "80",
                      prop: "quantity",
                      label: "订单总数量"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "right",
                      width: "80",
                      prop: "allocSumQuantity",
                      label: "已配货数量"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "right",
                      width: "80",
                      prop: "allocSumQuantity",
                      label: "可配数量"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  scope.row.quantity -
                                    scope.row.allocSumQuantity
                                )
                              )
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "right",
                      width: "110",
                      prop: "allocQuantity",
                      label: "本次配货数量"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop:
                                    "goodsOrderItemList" +
                                    scope.$index +
                                    "allocQuantity",
                                  rules: {
                                    validator: _vm.validateQuantity,
                                    trigger: "blur"
                                  }
                                }
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    disabled:
                                      scope.row.quantity -
                                        scope.row.allocSumQuantity <=
                                      0,
                                    type: "input"
                                  },
                                  model: {
                                    value: scope.row.allocQuantity,
                                    callback: function($$v) {
                                      _vm.$set(scope.row, "allocQuantity", $$v)
                                    },
                                    expression: "scope.row.allocQuantity"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { align: "left", width: "150", label: "说明" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("el-input", {
                              attrs: { type: "text" },
                              model: {
                                value: scope.row.desc,
                                callback: function($$v) {
                                  _vm.$set(scope.row, "desc", $$v)
                                },
                                expression: "scope.row.desc"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed bg-white" }, [
      _c("span", [_vm._v("基本信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed bg-white" }, [
      _c("span", [_vm._v("机构信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "head" }, [
      _c("tr", { staticClass: "row" }, [
        _c("th", { staticClass: "align-left" }, [_vm._v("机构名称")]),
        _vm._v(" "),
        _c("th", { staticClass: "align-left" }, [_vm._v("地址")]),
        _vm._v(" "),
        _c("th", [_vm._v("邮箱")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col"),
      _vm._v(" "),
      _c("col"),
      _vm._v(" "),
      _c("col", { attrs: { width: "150px" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "150px" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "head" }, [
      _c("tr", { staticClass: "row" }, [
        _c("th", { staticClass: "align-left" }, [_vm._v("省市县")]),
        _vm._v(" "),
        _c("th", { staticClass: "align-left" }, [_vm._v("详细地址")]),
        _vm._v(" "),
        _c("th", { staticClass: "align-left" }, [_vm._v("联系人")]),
        _vm._v(" "),
        _c("th", [_vm._v("电话")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed bg-white" }, [
      _c("span", [_vm._v("商品信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mb15" }, [
      _c("span", { staticClass: "font-red" }, [
        _vm._v("*温馨提示：可配数量=订单总数量-已配货数量。")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e737fe46", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e737fe46","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/order/OrderGoodsAllocItemSave.vue
// module id = 2671
// module chunks = 0